import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import vitalUpLight from "../../Assets/Projects/VitalUp/screenshots/dashboard/07_dashbaord_light.jpg";
import vitalUpDark from "../../Assets/Projects/VitalUp/screenshots/dashboard/01_dashboard_daily_overview.jpg";
import presentlyLight from "../../Assets/Projects/Presently/screenshots/dashboard/light/dashboard.jpg";
import presentlyDark from "../../Assets/Projects/Presently/screenshots/dashboard/dark/dashboard_dark.jpg";
import truxpenseLight from "../../Assets/Projects/TruXpense/screenshots/dashboard/light/dashboard.jpg";
import truxpenseDark from "../../Assets/Projects/TruXpense/screenshots/dashboard/dark/dashboard_quick_actions_and_budget.jpg";
import bunkBiteHome from "../../Assets/Projects/BunkBite/home.jpg";
import bunkBiteOrder from "../../Assets/Projects/BunkBite/myorder.jpg";
import vemsLight from "../../Assets/Projects/VEMS/screenshots/38536.jpg";
import vemsDark from "../../Assets/Projects/VEMS/screenshots/38537.jpg";

const Reveal = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(domRef.current);
        }
      });
    });
    const currentRef = domRef.current;
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div ref={domRef} className={`reveal ${isVisible ? "is-visible" : ""}`}>
      {children}
    </div>
  );
};

function Projects() {
  return (
    <Container fluid className="project-section" id="projects">
      <Container>
        <h1 className="project-heading" style={{ paddingBottom: "50px" }}>
          My Recent <strong className="purple">Works </strong>
        </h1>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={12} className="project-card" style={{ paddingBottom: "50px" }}>
            <Reveal>
              <ProjectCard
                lightImage={bunkBiteHome}
                darkImage={bunkBiteOrder}
                isPlayStore={true}
                isReversed={false}
                isBlog={false}
                title="BunkBite"
                description={
                  <>
                    A <b className="purple">cross-platform mobile application</b> published on the <b className="purple">Google Play Store</b> for 200+ students. Supports live menu browsing, order customization, and secure payments via REST APIs. Features <b className="purple">real-time order status updates</b> with FCM push notifications and <b className="purple">WebSocket</b> for low-latency communication. Built with <b className="purple">Flutter, Dart, BLoC</b>, and <b className="purple">Node.js/PostgreSQL</b> backend.
                  </>
                }
                ghLink="https://play.google.com/store/apps/details?id=com.bunkbite.app.canteenapp"
              />
            </Reveal>
          </Col>
 
          <Col md={12} className="project-card" style={{ paddingBottom: "50px" }}>
            <Reveal>
              <ProjectCard
                lightImage={presentlyLight}
                darkImage={presentlyDark}
                isReversed={true}
                isPlayStore={true}
                isBlog={false}
                title="Presently"
                description={
                  <>
                    A modern and elegant <b className="purple">college attendance tracker app</b> built to track and manage attendance seamlessly. Features <b className="purple">predictive attendance analytics</b>, offline-first architecture via <b className="purple">Room</b>, and automated <b className="purple">WorkManager</b> reminders. Deployed to the <b className="purple">Google Play Store</b>. Developed with <b className="purple">Kotlin, Jetpack Compose</b>, and <b className="purple">MVVM Architecture</b>.
                  </>
                }
                ghLink="https://play.google.com/store/apps/details?id=com.sdcsi.presently"
              />
            </Reveal>
          </Col>
 
          <Col md={12} className="project-card" style={{ paddingBottom: "50px" }}>
            <Reveal>
              <ProjectCard
                lightImage={vitalUpLight}
                darkImage={vitalUpDark}
                isReversed={false}
                isBlog={false}
                title="VitalUp"
                description={
                  <>
                    A production-grade <b className="purple">holistic health & fitness platform</b> featuring unified biometric tracking, an <b className="purple">AI vision food scanner</b> with dual-model failover (<b className="purple">Gemini Flash</b> & <b className="purple">Groq Llama-4</b>), automated macronutrient diet planning, and <b className="purple">Vita</b> (Conversational AI Health Coach). Powered by an <b className="purple">offline-first sync engine</b> with local <b className="purple">Isar DB</b> and <b className="purple">Supabase PostgreSQL</b>, native <b className="purple">Android home screen widgets</b>, and live GPS workout tracking with <b className="purple">TTS audio cues & BLE sensors</b>. Built with <b className="purple">Flutter, Dart, Clean Architecture</b>, and <b className="purple">BLoC pattern</b>.
                  </>
                }
                ghLink="https://github.com/TarunTalan/vital_up"
              />
            </Reveal>
          </Col>

          <Col md={12} className="project-card" style={{ paddingBottom: "50px" }}>
            <Reveal>
              <ProjectCard
                lightImage={vemsLight}
                darkImage={vemsDark}
                isReversed={true}
                isPlayStore={true}
                isBlog={false}
                title="VEMS"
                description={
                  <>
                    A <b className="purple">Vehicle Entry Management System</b> built with <b className="purple">Flutter</b> used at AKGEC. It handles student vehicle registration with <b className="purple">OTP-based signup</b>, document upload (RC, DL, College ID), and admin approval. Supports multiple roles including Student, Staff/Guard, and Admin with <b className="purple">Scanner integration</b> for entry/exit logging.
                  </>
                }
                ghLink="https://play.google.com/store/apps/details?id=com.sdcsi.vems"
              />
            </Reveal>
          </Col>
 
          <Col md={12} className="project-card" style={{ paddingBottom: "50px" }}>
            <Reveal>
              <ProjectCard
                lightImage={truxpenseLight}
                darkImage={truxpenseDark}
                isReversed={false}
                isBlog={false}
                title="TruXpense"
                description={
                  <>
                    An <b className="purple">AI-powered expense tracker</b> that automatically intercepts and parses bank SMS across 15+ Indian banks and integrates with <b className="purple">UPI deep-links</b> (GPay, PhonePe, Paytm) for zero manual entry. Features a server-side <b className="purple">BERT model</b> with on-device <b className="purple">MLKit</b> for merchant extraction achieving <b className="purple">92% accuracy</b>. Built with <b className="purple">Kotlin, Jetpack Compose, MVVM Architecture, Hilt DI, Room</b>, and a <b className="purple">Spring Boot</b> backend.
                  </>
                }
                ghLink="https://github.com/TarunTalan/TruXpense-app"
              />
            </Reveal>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
